import React, { useState, useEffect } from 'react';
import NavigationBar from './NavigationBar';
import HamburgerMenu from './HamburgerMenu';

function TermsOfServicePage({ navigateTo, goBack, userProfile, isLoggedIn }) {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #1e3a8a 0%, #1e40af 100%)',
      padding: isMobile ? '20px 16px 60px' : '40px 20px 80px',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
    }}>
      {!isMobile && <NavigationBar currentPage="terms" isLoggedIn={isLoggedIn} navigateTo={navigateTo} userProfile={userProfile} />}
      {isMobile && <HamburgerMenu currentPage="terms" isLoggedIn={isLoggedIn} navigateTo={navigateTo} userProfile={userProfile} />}
      
      <div style={{
        maxWidth: '800px',
        margin: '0 auto'
      }}>
        {/* Header */}
        <div style={{
          textAlign: 'center',
          marginBottom: '32px',
          marginTop: isMobile ? '50px' : '20px',
          color: 'white'
        }}>
          <h1 style={{
            fontSize: isMobile ? '28px' : '42px',
            fontWeight: isMobile ? '700' : '800',
            margin: '0 0 12px 0',
            letterSpacing: '-0.5px'
          }}>
            Terms of Service
          </h1>
          <p style={{
            fontSize: '14px',
            opacity: 0.9,
            margin: '0',
            fontWeight: '500'
          }}>
            Last updated: January 2026
          </p>
        </div>

        {/* Terms Content */}
        <div style={{
          background: 'white',
          borderRadius: '16px',
          padding: isMobile ? '28px 24px' : '40px 48px',
          boxShadow: '0 10px 40px rgba(0,0,0,0.3)',
          lineHeight: '1.8'
        }}>
          
          {/* Introduction */}
          <div style={{ marginBottom: '32px' }}>
            <p style={{
              fontSize: '16px',
              color: '#4B5563',
              margin: '0 0 16px 0'
            }}>
              Welcome to SudokuMatch. By accessing or using our service, you agree to be bound by these Terms of Service ("Terms"). Please read them carefully before using the platform.
            </p>
            <p style={{
              fontSize: '16px',
              color: '#4B5563',
              margin: '0'
            }}>
              If you do not agree to these Terms, you may not access or use SudokuMatch.
            </p>
          </div>

          {/* Section 1 */}
          <div style={{ marginBottom: '32px' }}>
            <h2 style={{
              fontSize: '22px',
              fontWeight: '700',
              color: '#1F2937',
              margin: '0 0 16px 0',
              letterSpacing: '-0.3px'
            }}>
              1. Acceptance of Terms
            </h2>
            <p style={{
              fontSize: '16px',
              color: '#4B5563',
              margin: '0 0 16px 0'
            }}>
              By creating an account or using SudokuMatch, you confirm that:
            </p>
            <ul style={{
              fontSize: '16px',
              color: '#4B5563',
              margin: '0',
              paddingLeft: '24px'
            }}>
              <li style={{ marginBottom: '8px' }}>You are at least 13 years of age</li>
              <li style={{ marginBottom: '8px' }}>You have the legal capacity to enter into these Terms</li>
              <li style={{ marginBottom: '8px' }}>You will comply with all applicable laws and regulations</li>
              <li>You agree to use the service in good faith</li>
            </ul>
          </div>

          {/* Section 2 */}
          <div style={{ marginBottom: '32px' }}>
            <h2 style={{
              fontSize: '22px',
              fontWeight: '700',
              color: '#1F2937',
              margin: '0 0 16px 0',
              letterSpacing: '-0.3px'
            }}>
              2. User Accounts
            </h2>
            <p style={{
              fontSize: '16px',
              color: '#4B5563',
              margin: '0 0 16px 0'
            }}>
              When you create an account, you agree to:
            </p>
            <ul style={{
              fontSize: '16px',
              color: '#4B5563',
              margin: '0 0 16px 0',
              paddingLeft: '24px'
            }}>
              <li style={{ marginBottom: '8px' }}>Provide accurate and complete information</li>
              <li style={{ marginBottom: '8px' }}>Keep your password secure and confidential</li>
              <li style={{ marginBottom: '8px' }}>Notify us immediately of any unauthorized access</li>
              <li>Be responsible for all activity under your account</li>
            </ul>
            <p style={{
              fontSize: '16px',
              color: '#4B5563',
              margin: '0'
            }}>
              You may not create multiple accounts to manipulate rankings, exploit the system, or circumvent restrictions.
            </p>
          </div>

          {/* Section 3 */}
          <div style={{ marginBottom: '32px' }}>
            <h2 style={{
              fontSize: '22px',
              fontWeight: '700',
              color: '#1F2937',
              margin: '0 0 16px 0',
              letterSpacing: '-0.3px'
            }}>
              3. Acceptable Use
            </h2>
            <p style={{
              fontSize: '16px',
              color: '#4B5563',
              margin: '0 0 16px 0'
            }}>
              You agree to use SudokuMatch only for lawful purposes. You may not:
            </p>
            <ul style={{
              fontSize: '16px',
              color: '#4B5563',
              margin: '0',
              paddingLeft: '24px'
            }}>
              <li style={{ marginBottom: '8px' }}>Use cheats, exploits, automation, bots, or scripts to gain unfair advantages</li>
              <li style={{ marginBottom: '8px' }}>Manipulate leaderboards or game results</li>
              <li style={{ marginBottom: '8px' }}>Harass, abuse, or harm other users</li>
              <li style={{ marginBottom: '8px' }}>Upload or transmit viruses, malware, or harmful code</li>
              <li style={{ marginBottom: '8px' }}>Attempt to access accounts, data, or systems you're not authorized to access</li>
              <li style={{ marginBottom: '8px' }}>Reverse engineer, decompile, or disassemble any part of the service</li>
              <li style={{ marginBottom: '8px' }}>Use the service for any commercial purpose without permission</li>
              <li>Violate any applicable laws or regulations</li>
            </ul>
          </div>

          {/* Section 4 */}
          <div style={{ marginBottom: '32px' }}>
            <h2 style={{
              fontSize: '22px',
              fontWeight: '700',
              color: '#1F2937',
              margin: '0 0 16px 0',
              letterSpacing: '-0.3px'
            }}>
              4. Fair Play and Anti-Cheating
            </h2>
            <p style={{
              fontSize: '16px',
              color: '#4B5563',
              margin: '0 0 16px 0'
            }}>
              SudokuMatch is committed to fair competition. We employ anti-cheat measures to ensure integrity:
            </p>
            <ul style={{
              fontSize: '16px',
              color: '#4B5563',
              margin: '0 0 16px 0',
              paddingLeft: '24px'
            }}>
              <li style={{ marginBottom: '8px' }}>Only one ranked attempt per puzzle per day is allowed</li>
              <li style={{ marginBottom: '8px' }}>Attempting to replay or manipulate puzzles will result in disqualification</li>
              <li style={{ marginBottom: '8px' }}>Suspicious patterns or impossible solve times may be investigated</li>
              <li>Verified cheating will result in account suspension or termination</li>
            </ul>
            <p style={{
              fontSize: '16px',
              color: '#4B5563',
              margin: '0'
            }}>
              We reserve the right to remove scores, rankings, or accounts that violate fair play principles.
            </p>
          </div>

          {/* Section 5 */}
          <div style={{ marginBottom: '32px' }}>
            <h2 style={{
              fontSize: '22px',
              fontWeight: '700',
              color: '#1F2937',
              margin: '0 0 16px 0',
              letterSpacing: '-0.3px'
            }}>
              5. Intellectual Property
            </h2>
            <p style={{
              fontSize: '16px',
              color: '#4B5563',
              margin: '0 0 16px 0'
            }}>
              All content, features, and functionality of SudokuMatch (including but not limited to puzzles, design, code, and graphics) are owned by SudokuMatch and protected by copyright, trademark, and other intellectual property laws.
            </p>
            <p style={{
              fontSize: '16px',
              color: '#4B5563',
              margin: '0'
            }}>
              You may not copy, reproduce, distribute, or create derivative works without our express written permission.
            </p>
          </div>

          {/* Section 6 */}
          <div style={{ marginBottom: '32px' }}>
            <h2 style={{
              fontSize: '22px',
              fontWeight: '700',
              color: '#1F2937',
              margin: '0 0 16px 0',
              letterSpacing: '-0.3px'
            }}>
              6. User Content and Leaderboards
            </h2>
            <p style={{
              fontSize: '16px',
              color: '#4B5563',
              margin: '0 0 16px 0'
            }}>
              By using SudokuMatch, you grant us the right to display your username, completion times, and rankings publicly on leaderboards and related features.
            </p>
            <p style={{
              fontSize: '16px',
              color: '#4B5563',
              margin: '0'
            }}>
              Your solve data contributes to the competitive environment and historical records of the platform.
            </p>
          </div>

          {/* Section 7 */}
          <div style={{ marginBottom: '32px' }}>
            <h2 style={{
              fontSize: '22px',
              fontWeight: '700',
              color: '#1F2937',
              margin: '0 0 16px 0',
              letterSpacing: '-0.3px'
            }}>
              7. Founder Programme
            </h2>
            <p style={{
              fontSize: '16px',
              color: '#4B5563',
              margin: '0 0 16px 0'
            }}>
              Participation in the Founder programme is optional and governed by separate terms outlined on the Founder page.
            </p>
            <p style={{
              fontSize: '16px',
              color: '#4B5563',
              margin: '0'
            }}>
              Founder benefits, badges, and perks are subject to the programme's specific terms and may change over time.
            </p>
          </div>

          {/* Section 8 */}
          <div style={{ marginBottom: '32px' }}>
            <h2 style={{
              fontSize: '22px',
              fontWeight: '700',
              color: '#1F2937',
              margin: '0 0 16px 0',
              letterSpacing: '-0.3px'
            }}>
              8. Service Availability
            </h2>
            <p style={{
              fontSize: '16px',
              color: '#4B5563',
              margin: '0 0 16px 0'
            }}>
              We strive to keep SudokuMatch available 24/7, but we do not guarantee uninterrupted access. The service may be unavailable due to:
            </p>
            <ul style={{
              fontSize: '16px',
              color: '#4B5563',
              margin: '0 0 16px 0',
              paddingLeft: '24px'
            }}>
              <li style={{ marginBottom: '8px' }}>Scheduled maintenance</li>
              <li style={{ marginBottom: '8px' }}>Technical issues or emergencies</li>
              <li style={{ marginBottom: '8px' }}>Factors beyond our control</li>
            </ul>
            <p style={{
              fontSize: '16px',
              color: '#4B5563',
              margin: '0'
            }}>
              We reserve the right to modify, suspend, or discontinue any part of the service at any time without notice.
            </p>
          </div>

          {/* Section 9 */}
          <div style={{ marginBottom: '32px' }}>
            <h2 style={{
              fontSize: '22px',
              fontWeight: '700',
              color: '#1F2937',
              margin: '0 0 16px 0',
              letterSpacing: '-0.3px'
            }}>
              9. Disclaimer of Warranties
            </h2>
            <p style={{
              fontSize: '16px',
              color: '#4B5563',
              margin: '0 0 16px 0'
            }}>
              SudokuMatch is provided "as is" and "as available" without warranties of any kind, either express or implied.
            </p>
            <p style={{
              fontSize: '16px',
              color: '#4B5563',
              margin: '0'
            }}>
              We do not guarantee that the service will be error-free, secure, or meet your expectations. You use SudokuMatch at your own risk.
            </p>
          </div>

          {/* Section 10 */}
          <div style={{ marginBottom: '32px' }}>
            <h2 style={{
              fontSize: '22px',
              fontWeight: '700',
              color: '#1F2937',
              margin: '0 0 16px 0',
              letterSpacing: '-0.3px'
            }}>
              10. Limitation of Liability
            </h2>
            <p style={{
              fontSize: '16px',
              color: '#4B5563',
              margin: '0 0 16px 0'
            }}>
              To the fullest extent permitted by law, SudokuMatch and its operators shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising from:
            </p>
            <ul style={{
              fontSize: '16px',
              color: '#4B5563',
              margin: '0 0 16px 0',
              paddingLeft: '24px'
            }}>
              <li style={{ marginBottom: '8px' }}>Your use or inability to use the service</li>
              <li style={{ marginBottom: '8px' }}>Loss of data or account access</li>
              <li style={{ marginBottom: '8px' }}>Service interruptions or errors</li>
              <li>Unauthorized access to your account</li>
            </ul>
            <p style={{
              fontSize: '16px',
              color: '#4B5563',
              margin: '0'
            }}>
              In no event shall our total liability exceed the amount you paid to use SudokuMatch (if any) in the past 12 months.
            </p>
          </div>

          {/* Section 11 */}
          <div style={{ marginBottom: '32px' }}>
            <h2 style={{
              fontSize: '22px',
              fontWeight: '700',
              color: '#1F2937',
              margin: '0 0 16px 0',
              letterSpacing: '-0.3px'
            }}>
              11. Termination
            </h2>
            <p style={{
              fontSize: '16px',
              color: '#4B5563',
              margin: '0 0 16px 0'
            }}>
              You may delete your account at any time by contacting hello@sudokumatch.com.
            </p>
            <p style={{
              fontSize: '16px',
              color: '#4B5563',
              margin: '0'
            }}>
              We reserve the right to suspend or terminate your account at any time for violations of these Terms, suspicious activity, or for any other reason at our discretion.
            </p>
          </div>

          {/* Section 12 */}
          <div style={{ marginBottom: '32px' }}>
            <h2 style={{
              fontSize: '22px',
              fontWeight: '700',
              color: '#1F2937',
              margin: '0 0 16px 0',
              letterSpacing: '-0.3px'
            }}>
              12. Changes to Terms
            </h2>
            <p style={{
              fontSize: '16px',
              color: '#4B5563',
              margin: '0 0 16px 0'
            }}>
              We may update these Terms from time to time. Changes will be effective when posted, with the "Last updated" date revised.
            </p>
            <p style={{
              fontSize: '16px',
              color: '#4B5563',
              margin: '0'
            }}>
              Continued use of SudokuMatch after changes constitutes acceptance of the updated Terms.
            </p>
          </div>

          {/* Section 13 */}
          <div style={{ marginBottom: '32px' }}>
            <h2 style={{
              fontSize: '22px',
              fontWeight: '700',
              color: '#1F2937',
              margin: '0 0 16px 0',
              letterSpacing: '-0.3px'
            }}>
              13. Governing Law
            </h2>
            <p style={{
              fontSize: '16px',
              color: '#4B5563',
              margin: '0'
            }}>
              These Terms are governed by the laws of the United Kingdom. Any disputes arising from these Terms or your use of SudokuMatch shall be resolved in UK courts.
            </p>
          </div>

          {/* Section 14 */}
          <div style={{ marginBottom: '32px' }}>
            <h2 style={{
              fontSize: '22px',
              fontWeight: '700',
              color: '#1F2937',
              margin: '0 0 16px 0',
              letterSpacing: '-0.3px'
            }}>
              14. Contact
            </h2>
            <p style={{
              fontSize: '16px',
              color: '#4B5563',
              margin: '0 0 16px 0'
            }}>
              If you have questions about these Terms, please contact us:
            </p>
            <div style={{
              background: '#F9FAFB',
              padding: '16px 20px',
              borderRadius: '8px',
              border: '1px solid #E5E7EB'
            }}>
              <p style={{
                fontSize: '16px',
                color: '#1F2937',
                margin: '0 0 8px 0',
                fontWeight: '600'
              }}>
                SudokuMatch
              </p>
              <p style={{
                fontSize: '16px',
                color: '#4B5563',
                margin: '0 0 4px 0'
              }}>
                Email: hello@sudokumatch.com
              </p>
              <p style={{
                fontSize: '16px',
                color: '#4B5563',
                margin: '0'
              }}>
                Location: United Kingdom
              </p>
            </div>
          </div>

          {/* Final Note */}
          <div style={{
            background: '#EFF6FF',
            padding: '20px 24px',
            borderRadius: '8px',
            border: '1px solid #BFDBFE'
          }}>
            <p style={{
              fontSize: '15px',
              color: '#1E40AF',
              margin: '0',
              fontWeight: '500'
            }}>
              <strong>Thank you for using SudokuMatch.</strong> By using our service responsibly and respectfully, you help create a fair and enjoyable environment for all players.
            </p>
          </div>
        </div>

        {/* Back Button */}
        <div style={{
          marginTop: '32px',
          textAlign: 'center'
        }}>
          <button
            onClick={() => goBack()}
            style={{
              background: 'rgba(255, 255, 255, 0.15)',
              backdropFilter: 'blur(10px)',
              border: '1px solid rgba(255, 255, 255, 0.25)',
              color: 'white',
              padding: '12px 32px',
              borderRadius: '10px',
              fontSize: '16px',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'all 0.2s ease'
            }}
            onMouseEnter={(e) => {
              e.target.style.background = 'rgba(255, 255, 255, 0.25)';
            }}
            onMouseLeave={(e) => {
              e.target.style.background = 'rgba(255, 255, 255, 0.15)';
            }}
          >
            ← Back
          </button>
        </div>
      </div>
    </div>
  );
}

export default TermsOfServicePage;
